export const ERROR_CODES = {
  LAST_COMMUNITY_MODERATOR: 'at_least_one_community_moderator_required',
  USER_ALREADY_HAS_GUARDIAN: 'dependents_user_has_guardian_proxy',
  PROVIDER_ALREADY_IN_CIRCLE: 'provider_already_in_circle',
  ACCESS_DENIED: 'access_denied',
  ALREADY_ASSIGNED: 'already assigned',
  DASHBOARD_SSN_TAKEN: 'dashboard_patient_ssn_taken_by_other_user',
  DASHBOARD_LOGIN_TAKEN: 'dashboard_patient_login_taken_by_other_user',
  RECORD_INVALID: 'record_invalid',
  APPOINTMENT_SCHEDULE_TIME_NOT_AVAILABLE: 'time_slot_not_available',
  APPOINTMENT_SCHEDULE_LIST_SERVICE_FAIL: 'third_party_error',
  UNAVAILABLE_VIRTUAL_ROOM: 'room_not_yet_available',
  LOGIN_NOT_FOUND: 'login_not_found',
  INVALID_LOGIN: 'invalid_login',
  INVALID_PHONE_NUMBER: 'invalid_phone_number',
  // TODO fix word typing
  PROVIDER_FROM_ANOTHER_ORGANIZATION: 'provider_from_another_orgazniation',
  TASK_ALREADY_COMPLETED: 'transition_not_allowed_error',
  REGISTRATION_NOT_FINISHED: 'registration_not_finished',
  PROVIDER_ALREADY_ASSIGNED: 'provider_already_assigned',
  LOCATION_SERVICE_CAPACITY: 'location_service_capacity_exceeded',
  PROVIDER_IS_NOT_AVAILABLE_FOR_THIS_TIME:
    'provider_is_not_available_for_this_time',
  PROVIDER_IS_NOT_AVAILABLE_FOR_SELECTED_SERVICE:
    'provider_is_not_available_for_selected_service_in_selected_location',
  APPOINTMENT_IS_EXISTING_AT_THIS_TIME:
    'there_is_already_an_existing_appointment_at_this_time_do_you_want_to_continue',
  APPOINTMENT_OVERLAPPING: 'appointment_overlapping',
  APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND: 'pricing_schedule_not_found',
  EHR_PROCESSING_ERROR: 'ehr_processing_error',
  APPOINTMENT_CANCELLATION_TIME_IS_OVER: 'appointment_cancelation_time_is_out',
};

export const LOGOUT_NOTIFICATIONS_ERRORS = {
  MULTIPLE_DEVICES: 'multiple_device_login',
  ENTITY_EXCEPTION: 'find_entity_exception',
};

export const DASHBOARD_RECORD_ERROR = {
  [ERROR_CODES.DASHBOARD_SSN_TAKEN]: 'errors.ssn.alreadyTakenBy',
  [ERROR_CODES.DASHBOARD_LOGIN_TAKEN]: 'errors.fieldAlreadyTaken',
};

export const APPOINTMENT_ERRORS = {
  [ERROR_CODES.APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND]:
    'errors.appointment.pricingNotAvailable',
  [ERROR_CODES.APPOINTMENT_SCHEDULE_TIME_NOT_AVAILABLE]:
    'errors.appointment.timeSlotNotAvailable',
};

export const LOGIN_ERROR_CODES = {
  AUTHENTICATION_LOCKOUT: 'authentication_lockout',
  UNAUTHORIZED: 'unauthorized',
  INVITE_NOT_CONFIRMED: 'invite_not_confirmed',
  INVITE_EXPIRED: 'invite_expired',
};

export const LOGIN_ERRORS = {
  [LOGIN_ERROR_CODES.AUTHENTICATION_LOCKOUT]:
    'errors.login.authenticationLockout',
  [LOGIN_ERROR_CODES.UNAUTHORIZED]: 'errors.login.unauthorized',
};

export const LOGIN_INVITATION_ERRORS = [
  LOGIN_ERROR_CODES.INVITE_NOT_CONFIRMED,
  LOGIN_ERROR_CODES.INVITE_EXPIRED,
];

export const DASHBOARD_RECORD_CAPACITY_ERRORS = [
  ERROR_CODES.LOCATION_SERVICE_CAPACITY,
];

export const PROGRAM_ERRORS = {
  ALREADY_COMPLETED: 'already_completed',
  INVITATION_REMOVED: 'invitation_removed',
};

export const INSURANCE_ERROR_CODES = {
  COPAY_NOT_RECEIVED: 'copay_not_received',
  INSURANCE_REQUEST_FAILED: 'insurance_eligibility_request_failed',
};

export const CHANGE_APPOINTMENT_STATUS_ERROR_CODES = [
  ERROR_CODES.EHR_PROCESSING_ERROR,
  ERROR_CODES.APPOINTMENT_CANCELLATION_TIME_IS_OVER,
];



// WEBPACK FOOTER //
// ./src/constants/errors.js